import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { chatApi } from '@/api/client';
import type { ChatThread } from '@/types/chat';

export function chatThreadsQueryKey(profileId: string) {
  return ['chat-threads', profileId] as const;
}

export function useChatThreads(profileId: string) {
  return useQuery({
    queryKey: chatThreadsQueryKey(profileId),
    queryFn: async () => {
      const res = await chatApi.listThreads(profileId, { limit: 30 });
      if (!res.success) throw new Error('Failed to load threads');
      return res.data?.threads ?? [];
    },
    enabled: Boolean(profileId),
  });
}

export function useCreateChatThread(profileId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (title?: string) => {
      const res = await chatApi.createThread(profileId, title ? { title } : undefined);
      if (!res.success || !res.data) throw new Error('Failed to create thread');
      return res.data as ChatThread;
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: chatThreadsQueryKey(profileId) });
    },
  });
}
